import { userApi } from '../api/userApi';

export const updateFavicon = async () => {
  try {
    const response = await userApi.getLogo();
    if (response?.image) {
      const favicon = document.getElementById('favicon');
      if (favicon) {
        favicon.href = response.image;
      }
    }
  } catch (error) {
    console.error('Error updating favicon:', error);
  }
};